// Fonts
import '../fonts/Altform-Black.woff2';
import '../fonts/Altform-BlackItalic.woff2';
import '../fonts/Altform-Bold.woff2';
import '../fonts/Altform-BoldItalic.woff2';
import '../fonts/Altform-ExtraLight.woff2';
import '../fonts/Altform-ExtraLightItalic.woff2';
import '../fonts/Altform-Light.woff2';
import '../fonts/Altform-LightItalic.woff2';
import '../fonts/Altform-Regular.woff2';
import '../fonts/Altform-RegularItalic.woff2';
import '../fonts/Altform-SemiBold.woff2';
import '../fonts/Altform-SemiBoldItalic.woff2';
import '../fonts/Altform-Thin.woff2';
import '../fonts/Altform-ThinItalic.woff2';

// Images
import '../img/email-logo.png';
import '../img/email-pattern.png';
import '../img/email-shim.gif';

import '../sass/main.scss';

import './common/custom-select.js';
import './common/focus.js';
import './common/screen-width.js';
import './common/screen-height.js';
import './common/anchors.js';
import './common/css-variables.js';
import './common/forms.js';

import './layouts/cookies-notice.js';
import './layouts/site-header.js';
import './layouts/site-nav.js';
import './layouts/site-footer.js';

import './common/on-screen.js';

import { initModals } from './common/modals.js';

(() => {
    initModals();
})();
